export const ADD_NOTIFICATION = 'ADD_NOTIFICATION'
export const ADD_NOTIFICATIONS = 'ADD_NOTIFICATIONS'
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION'
export const REMOVE_NOTIFICATIONS_OF_TYPE = 'REMOVE_NOTIFICATIONS_OF_TYPE'
